var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgXls = function SvgXls(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#15803D",
    fillRule: "evenodd",
    d: "M5 0h1.2c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C10 2.361 10 2.943 10 3.8v.039c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h.039c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819.037.45.038 1.032.038 1.889V17a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5Zm5 10a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Zm4 2a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Zm-8 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#15803D",
    d: "M11.956 1.748c-.04-.479-.117-.925-.292-1.347a9.021 9.021 0 0 1 5.935 5.935c-.422-.175-.868-.253-1.347-.292C15.71 6 15.046 6 14.242 6H14.2c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C12 4.75 12 4.377 12 3.8v-.041c0-.805 0-1.47-.044-2.01Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXls);
export default ForwardRef;